import styled from 'styled-components'

// Components
import UntypedDropdown, { StatelessDropdown } from 'components/Dropdown'
import Navbar from 'components/Navbar'

export const Dropdown = UntypedDropdown as any

export const IconWrapper = styled.div`
  position: absolute;
  right: 5px;
  bottom: 5px;
  display: flex;
  width: 18px;
  height: 18px;
  padding: 3px; /* stylelint-disable-line scales/space */
  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.primaryTint[100]};
  border: 2px solid ${({ theme }) => theme.colors.white};
  border-radius: 50%;
`

export const DropdownTrigger = styled(Navbar.Button)`
  padding: 0;
  height: 48px;
  width: 48px;
  justify-content: center;
  will-change: opacity;
  transition: opacity
    ${({ theme }) =>
      `${theme.transitions.duration[1]} ${theme.transitions.timing.easeInOut}`};
  &:hover {
    opacity: 0.75;
  }
`

export const UserDropdownWrapper = styled(StatelessDropdown)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const DropdownHeader = styled.div`
  padding: 4px 20px 8px 20px;
`

export const MenuSeparator = styled.hr`
  border-color: rgba(0, 0, 0, 0.06);
  margin: 8px 0;
`

export const UserDropdownItem = styled(Dropdown.Item.Anchor)`
  margin-bottom: 8px;
`

export const PersonIconWrapper = styled.div`
  margin-right: 8px;
`
